import * as React from 'react';
import { Helmet } from 'react-helmet';
import { translate } from 'react-i18next';
import { DEFAULT_LANG } from '../../../framework/constants/app';
import HelmetFactory from '../../../framework/factories/HelmetFactory';
import GoogleTagManager from '../../../services/GoogleTagManager';
class AppHelmet extends React.PureComponent {
    // shouldComponentUpdate(nextProps: IHelmetProps) {
    //   // only update helmet on language change
    //   // mutating children or other props requires a page refresh
    //   // added condition for filters for switch filter in title
    //   return (nextProps.lng !== this.props.lng) || !_isEqual(this.props.filters, nextProps.filters) ;
    // }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { t, children, lng } = this.props;
        if (!children) {
            if (lng !== prevProps.lng) {
                GoogleTagManager.setDefaultTitle(t('appTitle'));
            }
        }
    }
    componentDidMount() {
        const { t, children } = this.props;
        if (!children) {
            GoogleTagManager.setDefaultTitle(t('appTitle'));
        }
    }
    render() {
        const { t, page, pageProps, lng } = this.props;
        const HelmetConfig = HelmetFactory[page] && pageProps && pageProps.constructor === Object && Object.keys(pageProps).length !== 0
            ? HelmetFactory[page]({ t, ...pageProps })
            : HelmetFactory.DEFAULT();
        const { title, meta, ogImage, ogTitle, ogDescription, canonical, jsonLd } = HelmetConfig;
        return (React.createElement(Helmet, { defaultTitle: t('appTitle'), htmlAttributes: { lang: lng || DEFAULT_LANG } },
            title ? React.createElement("title", null, title) : false,
            meta ? React.createElement("meta", { name: 'description', content: meta }) : false,
            canonical ? React.createElement("link", { rel: 'canonical', href: canonical }) : false,
            ogTitle ? React.createElement("meta", { property: 'og:title', content: ogTitle }) : false,
            ogDescription ? React.createElement("meta", { property: 'og:description', content: ogDescription }) : false,
            ogImage ? React.createElement("meta", { property: 'og:image', content: ogImage }) : false,
            ogTitle ? React.createElement("meta", { property: 'og:type', content: 'website' }) : false,
            jsonLd ? React.createElement("script", { type: 'application/ld+json' }, JSON.stringify(jsonLd)) : false));
    }
}
export default translate(['common'])(AppHelmet);
